// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import Select from "../../../../../../../../components/Select/Select";
import api from "../../../../../../../../helpers/api";


export default class Collection extends React.PureComponent {

	async componentDidMount() {
		const {session} = this.props;

		if (session.context && session.context.partner && session.context.partner.role === 'disk') {
			/**
			 * Fetch the list of products that are available for purchase
			 */
			try {
				console.log("Loading allocation profiles...");
				const newStateProps = {};
				newStateProps.profiles = await api("/case/allocationprofiles", {
					ssn: session.context.partner.ssn,
					authToken: session.authToken
				});
				this.setState(newStateProps);
			}
			catch (e) {
				console.log(e);
			}
		}
	}

	render() {
		const {props, state} = this;
		const {index, session, fields} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		let partnerRole = "radgivare";
		if (session.context && session.context.partner && session.context.partner.role) {
			partnerRole = session.context.partner.role;
		}

		let allocationProfileOptions = [];
		let selectedAllocationIndex = -1;
		if (state != null) {
			for (let i = 0; i < state.profiles.length; i++) {
				allocationProfileOptions.push({
					label: state.profiles[i].name,
					value: state.profiles[i].name
				});

				if (fields.account_allocation_profile === state.profiles[i].name) {
					selectedAllocationIndex = i;
				}
			}
		}

		if (partnerRole === "disk" && allocationProfileOptions.length > 0) {
			return (
				<div className={classes} style={{width: "100%"}}>
					<h3>Diskretionär förvaltning</h3>

					<div style={{width: "100%", maxWidth: "480px", alignItems: "flex-start"}}>
						<strong>Välj diskretionär portfölj (allokeringsprofil)</strong>
						<Select
							style={{marginTop: "10px"}}
							name="account_allocation_profile"
							selectedIndex={selectedAllocationIndex}
							label="Välj"
							options={allocationProfileOptions}
							onChange={this._onSelectChange}
						/>
					</div>
				</div>
			);
		}

		return null;
	}

	_onSelectChange = (option, index) => {
		this.props.onFieldChange.call(this, "account_allocation_profile", option.value);
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/fair-gds-oppna/Fields/collections/CollectionAllocationProfile.js